import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities' 

class SubscriptionRepository{

    constructor() {
        this.basePath = store.state.backend;
    }

    createStripeSession(sessionConfig) {
        let headers = {'Authorization': store.state.token, "Stripe-Version" : "2023-10-16"};
        let response = axios.post(`${this.basePath}/ext/stripe/checkout`, sessionConfig, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    successfulResponseFromCheckout(sessionId) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/ext/stripe/payment/pending?sessionId=${sessionId}`, {headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    tokenizeCard(card) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/ePayco/register-client-with-card`, card,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    chargeSubscription(userId, planId, clubId) {
        let headers = {'Authorization': store.state.token};
        let data = { user_id: userId, plan_id: planId, club_id: clubId};
        let response = axios.post(`${this.basePath}/ePayco/charge-subscription`, data,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    subscriptionApproved(subInfo) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/paypal/subscription-registered`, subInfo,{headers: headers});
        response = verifyAuth(response) 
        return response;
        //return axios.post(`${this.basePath}/paypal/subscription-registered`, subInfo,{headers: headers});
    }

    lifetimeSubscriptionCompleted(subInfo) {
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/paypal/lifetime-order-activation`, subInfo,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getPlansByCoupon(couponName) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/coupon/${couponName}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }

    getReferredPlans(referredFrom) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/referrer/get-referred-plans?referredFrom=${referredFrom}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
    getPayment(sessionId){
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/payment?sessionId=${sessionId}`,{headers: headers});
        response = verifyAuth(response) 
        return response;
    }
    cancelSubscription(userId, reason) {
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/payment/cancel-subscription?user_id=${userId}&reason=${reason}`,{headers: headers});
        response = verifyAuth(response);
        return response;
    }

    susbriptionPlans(){
        let headers = {'Authorization': store.state.token};
        let response = axios.get(`${this.basePath}/subscription-plans`,{headers:headers});
        response = verifyAuth(response);
        return response;
    }

    purchaseAttempt(){
        let headers = {'Authorization': store.state.token};
        let response = axios.post(`${this.basePath}/purchase-attempt`,{},{headers: headers});
        response = verifyAuth(response);
        return response;
    }


}

export default new SubscriptionRepository();
